import log from 'loglevel';

/**
 * Placeholder standing in for JovoSocketIoSocket until a socketUrl is known.
 *
 * ConnectedWidget hands its socket ref to the store and the Widget component
 * at mount, before (or without ever) learning a socketUrl. Both call socket
 * methods freely — isConnected() on unmount, isInitialized()/createSocket()
 * on open, emit() from the middleware — so the stand-in must answer every
 * call the real class answers, doing nothing. A bare `{}` here turned a host
 * page without a socketUrl into a TypeError swallowed by the error boundary,
 * i.e. no launcher at all.
 *
 * `url` stays undefined on purpose: initSocketIoSocket (src/index.tsx) uses
 * `!instanceSocket.current.url` to decide that a real socket is still needed.
 */
export function createNoopSocket() {
    let initialized = false;
    return {
        url: undefined as string | undefined,
        marker: undefined as unknown,
        socket: null as unknown,
        sessionId: undefined as string | undefined,
        sessionConfirmed: false,
        customData: {} as Record<string, unknown>,
        isFirstMessage: () => true,
        isNewSession: () => false,
        getJovoRequestState: () => undefined as unknown,
        setJovoRequestState: () => {},
        clearJovoRequestState: () => {},
        clearSessionState: () => {},
        isInitialized: () => initialized,
        isConnected: () => false,
        createSocket: () => {
            // Mirrors the real class, where isInitialized() flips true once
            // createSocket() ran; otherwise the Widget keeps re-initialising
            // on every update.
            initialized = true;
            log.warn('no socketUrl configured — not connecting');
        },
        on: () => {},
        off: () => {},
        emit: () => {},
        emitWithCustomerInfo: () => {},
        emitWithoutSession: () => {},
        emitOnlyOnNewSession: () => {},
        emitPendingSessionMessages: () => {},
        close: () => {},
    };
}
